export const getSummaryBarStyles = (_, { palette = {} }) => ({
  summaryBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    height: '100%',
    borderBottom: `solid 1px ${palette.neutralQuaternaryAlt}`,
    background: palette.neutralLighter,
    '& > a': {
      color: palette.themeDarkAlt,
    },
    '& .icon-button': {
      '&:hover, &:active, &:focus': {
        background: palette.neutralQuaternaryAlt,
      },
    },
    '& .summary-bar-items': {
      display: 'flex',
      flexDirection: 'row',
      marginLeft: '8px',
      flexGrow: 1,
      '& .overflow-entity-items': {
        '&:hover, &:active, &:focus': {
          background: 'none',
        },
        minWidth: '33px',
        marginRight: 'auto',
      },
    },
    '& .summary-bar-items > div': {
      flex: '0 0 auto',
      marginLeft: '4px',
      marginRight: '4px',

      '& .entity-item': {
        paddingLeft: '4px',
        paddingRight: '4px',
        height: 44,
      },
      '& > div': {
        minHeight: '44px',
      },

      '& .entity-label': {
        paddingLeft: '4px',
        paddingRight: '4px',
      },
      '& .entity-content': {
        alignSelf: 'stretch',
        display: 'flex',
        justifyContent: 'space-between',
      },
      '& .entity-text': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        paddingLeft: '4px',
        paddingRight: '4px',
        '& .entity-first-item': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '& .entity-more': {
          marginLeft: 5,
          flexShrink: 0,
        },
      },
      '& .entity-multi-content': {
        display: 'flex',
        maxWidth: '120px',
        paddingLeft: '4px',
        paddingRight: '4px',
      },
      '&:hover, &:active, &:focus': {
        background: palette.neutralQuaternaryAlt,
      },
    },
    '& .summary-bar-divider': {
      flex: '0 1 auto',
      alignSelf: 'center',
      minWidth: '1px',
      height: '32px',
      background: palette.neutralQuaternaryAlt,
    },
    '& .summary-bar-status .dropdown-toggle': {
      '& > div': {
        width: '70px',
      },
      '&:hover, &:active, &:focus': {
        background: palette.neutralQuaternaryAlt,
      },
      '& .icon-ChevronDown': {
        margin: '4px 15px',
        marginRight: '0px',
      },
      backgroundColor: 'transparent',
      padding: '1px 0px',
      width: '100px',
    },
    '& .summary-bar-status': {
      '& .entity-item': {
        '& .entity-label': {
          paddingLeft: '20px',
        },
      },
    },
    '& .entity-link': {
      width: '120px',
      display: 'flex',
    },
    '& .summary-bar-settings': {
      '& .settings-item': {
        display: 'flex',
        alignItems: 'center',
      },
      '& .entity-icon': {
        marginRight: '10px',
      },
      '& .entity-content-settings': {
        backgroundColor: 'transparent',
        border: 'none',
      },
      marginRight: '16px',
      display: 'flex',
      alignItems: 'center',
      padding: '0px',
    },
    '& .overflow-entity-items': {
      '& .list-selector-item': {
        maxWidth: '200px',
      },
      '& > div': {
        background: 'none',
      },
    },
    '& .summary-bar-original-campaign': {
      '& .entity-text': {
        cursor: 'pointer',
      },
      '& .entity-text:hover': {
        color: palette.neutralDark,
      },
    },
    '& .overflow-item': {
      display: 'flex',
      '& .entity-label, & .entity-text': {
        paddingLeft: '10px',
      },
    },
    '& .overflow-summary-bar-items': {
      padding: '5px 0px 3px 0px',
    },
  },
  scopeBackButton: {
    display: 'flex',
    alignItems: 'center',
    '& .back-to-campaign-button-container': {
      paddingRight: '6px',
      '& .back-button, & .back-to-campaign-button': {
        marginTop: '0px',
        fontWeight: '400',
        backgroundColor: 'transparent !important',
        display: 'flex',
        alignItems: 'center',
        '& .iconba.iconba-Back': {
          color: palette.themePrimary,
          fontSize: '14px',
        },
        '&:hover': {
          backgroundColor: '#edebe9 !important',
        },
      },
    },
  },
  backButton: {
    alignItems: 'baseline',
    display: 'flex',
    marginTop: 'auto',
    marginBottom: 'auto',
    padding: '6px 15px 6px 6px',
    whiteSpace: 'nowrap',
  },
  backButtonIcon: {
    marginLeft: 4,
    marginRight: 4,
  },
});
